var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._b(
      { staticClass: "layout_container_board" },
      "div",
      _vm._d({}, [_vm.state.layoutAttr, true])
    ),
    [
      _vm.noVisibleFlows
        ? _c("div", { staticStyle: { "text-align": "center" } }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("generalNothingToShow")) + "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "draggable",
        _vm._b(
          _vm._b(
            {
              staticClass: "layout_draggable_board",
              attrs: {
                tag: "div",
                group: "flow",
                handle: ".kanban-flow",
                delay: "1000",
                "delay-on-touch-only": "true"
              },
              on: {
                start: function($event) {
                  _vm.drag = true
                },
                end: function($event) {
                  _vm.drag = false
                }
              },
              model: {
                value: _vm.flows,
                callback: function($$v) {
                  _vm.flows = $$v
                },
                expression: "flows"
              }
            },
            "draggable",
            _vm._d({}, [_vm.state.layoutAttr, true])
          ),
          "draggable",
          _vm.dragOptions,
          false
        ),
        [
          _c(
            "transition-group",
            _vm._b(
              {
                staticClass: "layout_transition_board",
                attrs: {
                  tag: "div",
                  type: "transition",
                  name: !_vm.drag ? "flip-list" : null
                }
              },
              "transition-group",
              _vm._d({}, [_vm.state.layoutAttr, true])
            ),
            _vm._l(_vm.flows, function(flow) {
              return _c("kanban-flow", {
                key: flow.id,
                ref: "kanbanFlow",
                refInFor: true,
                attrs: { state: _vm.state, board: _vm.board, flow: flow },
                on: {
                  reload: function($event) {
                    return _vm.$emit("reload")
                  },
                  openCard: function($event) {
                    return _vm.$emit("openCard", $event)
                  },
                  openPort: function($event) {
                    return _vm.$emit("openPort", $event)
                  }
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.state.archived
        ? _c(
            "div",
            _vm._b(
              { staticClass: "kanban-board-options-parent" },
              "div",
              _vm._d({}, [_vm.state.layoutAttr, true])
            ),
            [
              _c("div", { staticClass: "kanban-board-options" }, [
                _c("div", {}, [
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.newFlow === null,
                        expression: "newFlow === null"
                      }
                    ],
                    staticClass: "fas fa-plus",
                    attrs: {
                      title: _vm.$t("txtNewFlow"),
                      "data-v-step": "newflow"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        _vm.newFlow = ""
                        _vm.$nextTick(function() {
                          _vm.$refs.newflow.focus()
                        })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.newFlow !== null,
                          expression: "newFlow !== null"
                        }
                      ],
                      staticClass: "input-group"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newFlow,
                            expression: "newFlow"
                          }
                        ],
                        ref: "newflow",
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.newFlow },
                        on: {
                          keyup: [
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.createFlow.apply(null, arguments)
                            },
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "esc", 27, $event.key, [
                                  "Esc",
                                  "Escape"
                                ])
                              )
                                return null
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.newFlow = null
                            }
                          ],
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.newFlow = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            attrs: { type: "button" },
                            on: { click: _vm.createFlow }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("btnCreate")) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.newFlow = null
                              }
                            }
                          },
                          [_vm._v("×")]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }